module.exports = __webpack_public_path__ + "img/iv_b4_img2.3b75f387.png";